<template>
    <div class="checkout">
        <div class="stripe checkout__inner" :class="{ 'checkout__inner--push': acceptOffline && acceptOnline }">
            <nav class="checkout__nav" v-if="acceptOffline && acceptOnline">
                <span :class="{ active: state === 'online' }"
                      @click="change('online')">{{ __('Online Payment') }}</span>
                <span :class="{ active: state === 'offline' }"
                      @click="change('offline')">{{ __('Offline Payment') }}</span>
            </nav>

            <!-- Slot is always online! -->
            <slot v-if="state === 'online'"/>
            <div v-else-if="state === 'offline'" class="checkout__msg">
                <p>{{ __('Your payment will be deferred, and an invoice will be raised and emailed to the billing email address you have provided.') }}</p>
                <a :href="'/' + offlineSlug" class="button  btn  btn--tertiary">{{ __('Complete order') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'checkout',

        props: {
            acceptOffline: {
                type: Boolean,
                required: false,
                default: false
            },
            acceptOnline: {
                type: Boolean,
                required: false,
                default: true
            },
            offlineSlug: {
                type: String,
                required: false,
                default: 'booking/offline'
            }
        },

        data: function () {
            return {
                state: 'online'
            }
        },

        mounted: function () {
            this.state === this.acceptOnline ? 'online' : ( this.acceptOffline ? 'offline' : 'n/a' );
        },

        methods: {
            change: function ( to ) {
                this.state = to;
            }
        }
    }
</script>

<style lang="scss">
    .checkout {
        &__inner {
            position: relative;

            &--push {
                margin-top: 3rem;
            }
        }

        &__btn {
            margin-top: 1.5rem !important;
        }

        &__msg {
            text-align: center;
            padding-top: 1rem;
        }

        &__nav {
            position: absolute;
            top: -40px;
            left: -2px;

            span {
                display: inline-block;

                padding: 0.85rem 1rem;

                font-size: 14px;
                line-height: 14px;
                text-align: center;
                text-transform: uppercase;
                font-weight: 200;
                letter-spacing: 2px;
                cursor: pointer;

                &.active {
                    background-color: #EFEFEF;
                    border: 2px solid #E9E9E9;
                    border-bottom: 0;

                    font-weight: 400;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/Checkout.vue